import {Accordion, AccordionTab} from 'primereact/accordion';
import {Card} from 'primereact/card';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionButton from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import YesNoDialog from '../components/YesNoDialog';
import OrderFuelService from '../services/OrderFuelService';
import {AnwimLpgDeliveryContainer} from './AnwimLpgDeliveryContainer';
import FuelOrderTemplateEditDialog from './FuelOrderTemplateEditDialog';
import {OwnDeliveryContainer} from './OwnDeliveryContainer';

class DraftListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new OrderFuelService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            removeConfirmationVisible: false,
            editTemplateVisible: false,
        };
        this.hideConfirmationRemoveTemplateDialog = this.hideConfirmationRemoveTemplateDialog.bind(this);
        this.showConfirmationRemoveTemplateDialog = this.showConfirmationRemoveTemplateDialog.bind(this);
        this.hideEditTemplateDialog = this.hideEditTemplateDialog.bind(this);
        this.showEditTemplateDialog = this.showEditTemplateDialog.bind(this);
        this.user = this.authService.getProfile();
    }

    hideConfirmationRemoveTemplateDialog(value) {
        const {t} = this.props;
        if (!!value) {
            this.props.blockUi();
            this.service
                .remove(this.state.toRemove)
                .then(() => {
                    this.setState({removeConfirmationVisible: false, toRemove: undefined}, () => {
                        this.showSuccessMessage(t('order-card.removeTemplateSuccess'));
                        this.refreshTable();
                    });
                })
                .catch((err) => {
                    this.setState({removeConfirmationVisible: false, toRemove: undefined}, () => {
                        this.showErrorMessage(t('error.removeOrderCardError'));
                        this.props.unblockUi();
                    });
                });
        } else {
            this.setState({removeConfirmationVisible: false, toRemove: undefined});
        }
    }

    showConfirmationRemoveTemplateDialog(element) {
        this.setState({removeConfirmationVisible: true, toRemove: element});
    }

    showEditTemplateDialog(element) {
        this.setState({editTemplateVisible: true, editionElement: element});
    }

    hideEditTemplateDialog(e, callback) {
        this.setState({editTemplateVisible: false, editionElement: undefined}, () => {
            if (callback) {
                callback();
            }
        });
    }

    getDataKey() {
        return 'petraId';
    }

    getListTitle() {
        return 'cards.listTitle';
    }

    updateSearchCriteria(criteria) {
        return {
            draft: true,
        };
    }

    getCleanSearchCriteria() {
        return {
            draft: true,
        };
    }

    initializeFromBackend() {}

    getCriteriaName() {
        return 'order-list-sc';
    }

    getContainerListName() {
        return 'draft-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderFilter() {
        return null;
    }

    renderCriteria() {
        return null;
    }

    prepareHeaderItems() {
        return [];
    }

    render() {
        const {t} = this.props;
        return (
            <DivContainer colClass='container-fluid order-fuel list'>
                <DivContainer colClass='dashboard'>
                    {this.state.editionElement !== undefined ? (
                        <FuelOrderTemplateEditDialog
                            key={'fuel-order-template-dialog'}
                            blockUi={this.props.blockUi}
                            unblockUi={this.props.unblockUi}
                            ids={this.state.ids}
                            cards={this.state.cards}
                            element={this.state.editionElement}
                            onHide={(e) =>
                                this.hideEditTemplateDialog(e, () => {
                                    this.readMessage();
                                    this.refreshTable();
                                })
                            }
                            visible={this.state.editTemplateVisible}
                            viewMode={'EDIT'}
                            afterSave={(e) =>
                                this.hideEditTemplateDialog(e, () => {
                                    this.readMessage();
                                    this.refreshTable();
                                })
                            }
                            containerListName={this.getContainerListName()}
                            _isMounted={this._isMounted}
                        />
                    ) : null}
                        {this.renderAddToTrustedDevicesDialog()}
                    <YesNoDialog
                        visible={this.state.removeConfirmationVisible}
                        header={t('order-card.removeTemplateDialogHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            this.hideConfirmationRemoveTemplateDialog(target.value);
                        }}
                        onHide={() => {
                            this.hideConfirmationRemoveTemplateDialog(false);
                        }}
                        noButtonVariant='button cancel-button white'
                        yesButtonVariant='button save-button fullred'
                    >
                        {t('order-card.removeTemplateDialogConfirmation')}
                    </YesNoDialog>
                    <form>
                        <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                            <DivContainer colClass='row'>
                                <Accordion multiple>
                                    {this.state.list && this.state.list.length
                                        ? this.state.list.map((element, index) => {
                                              return (
                                                  <AccordionTab
                                                      header={this.renderDraftHeader(element.draftName)}
                                                      key={`header-${element.draftName}-${index}`}
                                                  >
                                                      <DivContainer colClass='dashboard'>
                                                          <DivContainer colClass='col-12 dashboard-link-container'>
                                                              <DivContainer colClass=' template-list-col-padding'>
                                                                  {this.renderAddressSummary(element)}
                                                                  {!element.anwimDelivery && !element.adBlueLpg
                                                                      ? this.renderDriverVehicleSummary(element)
                                                                      : null}
                                                                  {this.renderFuelsSummary(element)}
                                                              </DivContainer>
                                                              <div className='template-list-buttons'>
                                                                  <div className='left'>
                                                                      <ActionButton
                                                                          label={t('details.delete')}
                                                                          variant='button cancel-button red'
                                                                          handleClick={(e) => {
                                                                              if (e) {
                                                                                  e.preventDefault();
                                                                              }
                                                                              this.showConfirmationRemoveTemplateDialog(element);
                                                                          }}
                                                                      />

                                                                      <ActionButton
                                                                          label={t('details.editButton')}
                                                                          variant='editButton white'
                                                                          handleClick={(e) => {
                                                                              if (e) {
                                                                                  e.preventDefault();
                                                                              }
                                                                              window.location.href = `${this.props.editUrl}${element.petraId}`;
                                                                              this.showEditTemplateDialog(element);
                                                                          }}
                                                                      />
                                                                  </div>
                                                                  <div className='right'>
                                                                      <ActionButton
                                                                          label={t('order-fuel.orderAgain')}
                                                                          variant='editButton blue'
                                                                          handleClick={() =>
                                                                              (window.location.href = `${this.props.orderAgainUrl}${element.petraId}`)
                                                                          }
                                                                      />
                                                                  </div>
                                                              </div>
                                                          </DivContainer>
                                                      </DivContainer>
                                                  </AccordionTab>
                                              );
                                          })
                                        : null}
                                </Accordion>
                            </DivContainer>
                        </DivContainer>
                    </form>
                </DivContainer>
            </DivContainer>
        );
    }

    renderOwnDeliverySummary(element) {
        return (
            <OwnDeliveryContainer
                agreementEmail={this.user.agreementEmail}
                carrierEmail={element.carrierEmail}
                deliveryPlaces={this.state.deliveryPlaces}
                t={this.props.t}
                summary={true}
                element={element}
                validator={this.validator}
                handleChange={this.handleChange}
                orderTypeOptions={this.state.orderTypeOptions}
                ownDeliverPurposeTypeOpt={this.state.ownDeliverPurposeTypeOpt}
                fuelBases={this.state.fuelBases}
                onAfterTransportTypeChange={this.onAfterTransportTypeChange}
                handleHideTooltip={this.handleHideTooltip}
                handleShowTooltip={this.handleShowTooltip}
                handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                onTooltipClick={this.onTooltipClick}
                sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                dialogMode
                templateEdit
            />
        );
    }

    renderAnwimDeliveryOrLpgAdBlue2or4PageFragment(element) {
        return (
            <AnwimLpgDeliveryContainer
                t={this.props.t}
                summaryPage={true}
                element={element}
                validator={this.validator}
                agreementEmail={this.user.agreementEmail}
                deliveryPlaces={this.state.deliveryPlaces}
                handleChange={this.handleChange}
                orderTypeOptions={this.state.orderTypeOptions}
                handleHideTooltip={this.handleHideTooltip}
                handleShowTooltip={this.handleShowTooltip}
                handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                onTooltipClick={this.onTooltipClick}
                sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                templateEdit
                dialogMode
            />
        );
    }

    renderAddressSummary(element) {
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container'>
                            <Card>
                                {!!element.anwimDelivery || !!element.adBlueLpg
                                    ? this.renderAnwimDeliveryOrLpgAdBlue2or4PageFragment(element)
                                    : this.renderOwnDeliverySummary(element)}
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    renderDriverVehicleSummary(element) {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container'>
                            <Card>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-12'>
                                        <InputTextComponent
                                            id='driver-summary'
                                            name='driver'
                                            label={t('order-fuel.driver')}
                                            colClass='col-12'
                                            value={element.driver}
                                            renderValue={() => {
                                                return element.driver ? (
                                                    <React.Fragment>
                                                        <label className='black-labels flex-inputs'>{`${element.driver.firstName} ${element.driver.lastName}`}</label>
                                                        <label className='white-labels flex-inputs'>PESEL: {element.driver.pesel}</label>
                                                        <label className='white-labels flex-inputs'>
                                                            {t('order-fuel.docNumber')}: {element.driver.documentNumber}
                                                        </label>
                                                    </React.Fragment>
                                                ) : (
                                                    <label />
                                                );
                                            }}
                                            viewMode={'VIEW'}
                                        />
                                    </div>
                                    <div className='col-md-4 col-sm-12'>
                                        <InputTextComponent
                                            id='vehicle-summary'
                                            name='vehicle'
                                            label={t('order-fuel.vehicle')}
                                            colClass='col-lg-6 col-md-12 col-sm-12'
                                            value={element.vehicle}
                                            renderValue={() => {
                                                return element.vehicle && element.vehicle?.registrationNumber ? (
                                                    <React.Fragment>
                                                        <label className='black-labels flex-inputs'>
                                                            {element.vehicle.registrationNumber}
                                                        </label>
                                                        <label className='white-labels flex-inputs'>
                                                            {!!element.vehicle?.own
                                                                ? t('order-fuel.vehicle-own-true')
                                                                : t('order-fuel.vehicle-own-false')}
                                                        </label>
                                                    </React.Fragment>
                                                ) : (
                                                    <label />
                                                );
                                            }}
                                            viewMode={'VIEW'}
                                        />
                                    </div>
                                    <div className='col-md-4 col-sm-12'>
                                        <InputTextComponent
                                            id='trailer-summary'
                                            name='trailer'
                                            label={t('order-fuel.trailer')}
                                            colClass='col-lg-6 col-md-12 col-sm-12'
                                            value={element.trailer}
                                            renderValue={() => {
                                                return element.trailer && element.trailer?.registrationNumber && element.trailer?.type ? (
                                                    <React.Fragment>
                                                        <label className='black-labels flex-inputs'>
                                                            {element.trailer.registrationNumber}
                                                        </label>
                                                        <label className='white-labels flex-inputs'>
                                                            {t(`EcTrailerType.${element.trailer.type}`)}
                                                        </label>
                                                        <label className='white-labels flex-inputs'>
                                                            {!!element.trailer?.own
                                                                ? t('order-fuel.trailer-own-true')
                                                                : t('order-fuel.trailer-own-false')}
                                                        </label>
                                                    </React.Fragment>
                                                ) : (
                                                    <label />
                                                );
                                            }}
                                            viewMode={'VIEW'}
                                        />
                                    </div>
                                </div>
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    renderFuelsSummary(element) {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container gray-background'>
                            <Card>
                                {element.fuels && element.fuels.length
                                    ? element.fuels.map((fuel, index) => {
                                          const backgroundColor = fuel?.fuel?.color ? fuel.fuel.color : '#090E22';
                                          return (
                                              <React.Fragment key={`fuel-summary-${fuel.name ? fuel.name : index}`}>
                                                  <div className='row'>
                                                      <InputTextComponent
                                                          validator={this.validator}
                                                          id={`${index}-fuel-summary`}
                                                          name='fuel'
                                                          label={t('order-fuel.fuels')}
                                                          colClass='col-12'
                                                          viewMode={'VIEW'}
                                                          showLabel={index === 0}
                                                          onChange={this.props.handleChange}
                                                          value={fuel.name}
                                                          renderValue={() => {
                                                              return fuel ? (
                                                                  <React.Fragment>
                                                                      <label
                                                                          className='black-labels flex-inputs'
                                                                          style={{backgroundColor: backgroundColor}}
                                                                      >
                                                                          {t(`products.${fuel?.fuel?.name}`)}
                                                                      </label>
                                                                      <label className='white-labels flex-inputs'>
                                                                          {fuel.quantity} m<sup>3</sup> ({fuel.volume} l)
                                                                      </label>
                                                                  </React.Fragment>
                                                              ) : (
                                                                  <label />
                                                              );
                                                          }}
                                                      />
                                                  </div>
                                              </React.Fragment>
                                          );
                                      })
                                    : null}
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    onAfterGetList(res) {
        this.props.onAfterGetList(res);
        this.props.unblockUi();
    }

    afterGetListError() {
        this.props.afterGetListError();
    }

    refreshTable() {
        this.props.blockUi(this.getList);
    }

    renderDraftHeader(name) {
        const headerItems = [
            {
                label: name,
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_draft_order_card_header',
            },
        ];

        return this.prepareHeader(headerItems);
    }

    labelHeader(item, index) {
        return (
            <div className={`pageheader-title ${item.className}`} key={item.label + index}>
                {item.iconSvg ? <img className='card-icon' alt={item.label} src={`/images/${item.iconSvg}.svg`} /> : null}
                {item.label}
            </div>
        );
    }
}

DraftListContainer.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
    cardTypePanels: false,
    detailUrl: '#/card-details',
    orderAgainUrl: '#/order-fuel-again/',
    editUrl: '#/order-fuel-template-edit/',
};

DraftListContainer.propTypes = {
    phoneNumber: PropTypes.string,
    cardTypePanels: PropTypes.bool,
    handleGoToDetail: PropTypes.func,
};

export default withTranslation()(DraftListContainer);
